<template>
  <div id="main" style="height: calc(100% - 80px)">
    <!-- 碳排放强度 -->
  </div>
</template>

<script>
import * as echarts from 'echarts';
export default {
  name: "emissionIntensity",
  props: ['intensityxData', 'intensityFirstData', 'intensitySecondData'],
  data () {
    return {
      myChartemiss: null
    }
  },
  methods: {

  },
  watch: {
    intensityxData: {
      handler (newName, oldName) {
        if (newName != null) {
          let that = this
          // debugger
          setTimeout(function () {
            that.chartInvid()
          }, 1000)
        }
      },
      immediate: true
    }
  },
  methods: {
    chartInvid () {
      this.myChartemiss = echarts.init(document.getElementById("main"));
      this.myChartemiss.setOption(this.option);
    }
    // chartInvid () {
    //   this.option && myChartemiss.setOption(ths.option);
    // }
  },
  mounted () {

    var myChartemiss = echarts.init(document.getElementById('main'));
    this.chartInvid()
  },
  computed: {
    option () {
      return {
        title: {
          //text: '单位:万tCO₂',
          text: '单位:万元',//用能耗费
          textStyle: {
            color: '#fff',
            fontSize: 12,
          }
        },
        tooltip: {
          padding: [8, 10, 8, 10],
          backgroundColor: 'rgba(9,17,24)',
          borderWidth: 1,
          borderColor: '#45a2ff',
          trigger: 'axis',
          formatter: function (params) {
            var res = ''
            for (var i = 0, l = params.length; i < l; i++) {
              res += params[i].seriesName + ' : ' + params[i].value + '<br/>';//鼠标悬浮显示的字符串内容
              // console.log(res)
            }
            var str = `<div style="color:#fff; background-size: cover;;font-size:16px;">`
              + res +
              `</div>`;
            // parms.marker
            // console.log(params);
            return str;

          }
        },
        legend: {
          // data: ['Email', 'Union Ads'],
          right: 10,
          textStyle: {
            color: '#fff',
            fontSize: 12
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          // feature: {
          //   saveAsImage: {}
          // }
        },
        xAxis: {
          // show: 'false,
          type: 'category',
          boundaryGap: true,
          data: this.intensityxData,
          axisLine: {
            show: true,
            lineStyle: {
              color: '#45a2ff',
            },
          },
          splitLine: { show: false },//去除网格线
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 16,
            color: '#fff',
          },
        },
        yAxis: {
          type: 'value',
          axisLine: {
            show: true,
            lineStyle: {
              color: '#45a2ff',
            },
          },
          splitLine: {
            show: false,
            lineStyle: {
              color: '#182266',
            },
          },
          axisTick: {
            show: false,
          },
          axisLabel: {
            fontSize: 16,
            color: '#fff',
          },
        },
        series: [
          {
            name: '1号线',
            type: 'line',
            // stack: 'Total',
            showSymbol: true,//是否默认展示圆点
            legendHoverLink: true,
            // 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
            symbol: 'circle',     //设定为实心点
            symbolSize: 12,   //设定实心点的大小
            data: [300,400,500,0]
          },
          {
            name: '2号线',
            type: 'line',
            // stack: 'Total',
            showSymbol: true,//是否默认展示圆点
            legendHoverLink: true,
            // 'circle', 'rect', 'roundRect', 'triangle', 'diamond', 'pin', 'arrow', 'none'
            symbol: 'circle',     //设定为实心点
            symbolSize: 12,   //设定实心点的大小
            data: [200,300,400,0]
          }
        ]
      }
    }
  },

}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/left/emissionIntensity.vue